import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import '../UtilityComponents/CustomDate.css';

import { useEffect } from 'react';

const CustomInput = React.forwardRef(({ onClick, value, readOnly, ...rest }, ref) => {
    return (
        <input
            onClick={onClick}
            value={value}
            readOnly={true}
            {...rest}
            type="text"
            ref={ref}
        />
    );
});


const CustomDatePicker = (props) => {
    const [startDate, setStartDate] = useState('');
    const [MaxDate, setMaxDate] = useState('');
    const [MinDate, setMinDate] = useState('');

    

   
    useEffect(() => {
        if (props.maxDate !== undefined) {
            setMaxDate(props.maxDate)
        }
        if (props.minDate !== undefined) {
            setMinDate(props.minDate)
        }
    },[props.maxDate, props.minDate])

    useEffect(() => {
        if (props.RegDate !== "" && props.RegDate !== null && props?.RegDate !== undefined) {
            setStartDate(props.RegDate);
        }
    }, [props.RegDate])

    const handleKeyDown = (e) => {
        // Allow only numeric characters (0-9) and backspace
        if (!/^[0-9 -]$/.test(e.key) && e.key !== 'Backspace') {
            e.preventDefault();
        }
    };

    return (
        <div className="mui-datepicker">
            <i class="datepicker-icon fa fa-calendar"></i>
            <DatePicker
                selected={startDate}
                onKeyDown={handleKeyDown}
                onChange={(date) => { props.setDOB(date); setStartDate(date) }}
                minDate={MinDate}
                maxDate={MaxDate}
                showYearDropdown
                // dateFormatCalendar="MMMM"
                yearDropdownItemNumber={40}
                placeholderText="dd-MM-yyyy"
                dateFormat="dd-MM-yyyy"
                peekNextMonth
                showMonthDropdown
                scrollableMonthDropdown
                showIcon
                showYearDropdown
                scrollableYearDropdown
                customInput={< CustomInput />}
            />
        </div>
    );
};

export default CustomDatePicker;
